module.exports = __webpack_public_path__ + "Roboto-Medium.1561b424aaef2f704bbd.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/roboto/Roboto-Medium.woff2
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Medium.woff2
// module chunks = styles